
import { LightningElement, api, track } from 'lwc';
import { publicPropertyToBool } from '../../../utils/basicUtils';

let KEY_ID = 5232312;
export default class sldsIllustration extends LightningElement {
    _helpTextCl = 'header-text_medium slds-text-color_weak';

    @api 
    set size(value) {
        this._size = value;
        switch(value) {
            case 'xx-small':
                this._helpTextCl = 'slds-text-color_weak header-text_x-small'; break;
            case 'x-small':
                this._helpTextCl = 'slds-text-color_weak header-text_small'; break;
            case 'small':
                this._helpTextCl = 'slds-text-color_weak header-text_medium'; break;
            case 'large':
                this._helpTextCl = 'slds-text-color_weak header-text_large'; break;
        }
    }
    get size() {return this._size;}

    @api isButton = false;

    // ============= User Help Messages ============== \\
    _helpText = '';
    @api 
    set helpText(value) {this._helpText = value;}
    get helpText() {return this._helpText;}

    _isAdditionalHelpTextArr = false;
    _additionalHelpText = '';
    @api 
    set additionalHelpText(value) {
        if (value) {
            if (Array.isArray(value)) {
                this._isAdditionalHelpTextArr = true;
                this._additionalHelpText = value.map(v => ({msg: v, keyId: String(KEY_ID++)}));
            } else {
                this._isAdditionalHelpTextArr = false;
                this._additionalHelpText = value;
            }
        }
    }
    get additionalHelpText() {return this._additionalHelpText;}
    @api 
    set callToAction(value) {this._callToAction = value;}
    get callToAction() {return this._callToAction;}
    // =============================================== \\

    @api 
    set isNoContent(value) {this._isNoContent = publicPropertyToBool(value);}
    get isNoContent() {return this._isNoContent;}

    @api isFishing = false;
    @api isCamping = false;
    @api isHammock = false;

    @api 
    set isNoData(value) {this._isNoData = publicPropertyToBool(value);}
    get isNoData() {return this._isNoData;}
    // ============ No Data Illustrations ============ \\
    @api 
    set isOpenRoad(value) {this._isOpenRoad = publicPropertyToBool(value);}
    get isOpenRoad() {return this._isOpenRoad;}
    // =============================================== \\
    

    @api 
    set isError(value) {this._isError = publicPropertyToBool(value);}
    get isError() {return this._isError;}

    // ============= Error Illustrations ============= \\
    @api 
    set isNoAccess(value) {this._isNoAccess = publicPropertyToBool(value);}
    get isNoAccess() {return this._isNoAccess;}
    @api 
    set isNoConnection(value) {this._isNoConnection = publicPropertyToBool(value);}
    get isNoConnection() {return this._isNoConnection;}
    @api 
    set isPageNotAvailable(value) {this._isPageNotAvailable = publicPropertyToBool(value);}
    get isPageNotAvailable() {return this._isPageNotAvailable;}
    @api 
    set isNoPreview(value) {
        this._isNoPreview = publicPropertyToBool(value);
    }
    get isNoPreview() {
        return this._isNoPreview;
    }
    // =============================================== \\

    get isDashThrough() {
        return !this.isNoData && 
            !this.isError && 
            !this.isNoContent &&
            !this.isHammock && 
            !this.isFishing && 
            !this.isCamping
    }


    // Notify parent of call to action
    handleCallToAction() {
        // Send event to parent with the value
        this.dispatchEvent(new CustomEvent('action', { detail: 'action' } ));   
    }

    get sizeClass() {
        switch(this.size) {
            case 'xx-small':
                return 'slds-illustration xx-small-illustration';
            case 'x-small':
                return 'slds-illustration x-small-illustration';
            case 'large':
                return 'slds-illustration slds-illustration_large';
            default:
                return 'slds-illustration slds-illustration_small';
        }
    }

    get buttonCl() {
        return this.isButton
            ? 'slds-button slds-button_brand'
            : 'slds-button'
    }

    get helpTextCl() {
        return this.size && (this.size === 'x-small' ||  this.size === 'xx-small')
            ? 'slds-text-heading_small'
            : 'slds-text-heading_medium'; 
    }


    _hasRendered = false;
    renderedCallback() {
        if (this.size && this.size === 'fill' && !this._hasRendered) {
            const svg = this.template.querySelector('svg');
            if (svg) {
                svg.classList.add('gw-illustration__svg');
            }
        }
    }

}